import React, {useEffect} from 'react';
// import usePhotoFirestore from '../hooks/usePhotoFirestore';
import useThumbFirestore from '../hooks/useThumbFirestore';
import Box from '@material-ui/core/Box';
import ImageList from '@material-ui/core/ImageList';
import ImageListItem from '@material-ui/core/ImageListItem';
import Lightbox from 'react-image-lightbox';
import { WaveLoading } from 'react-loadingg';
const WaveAnimation = () => <WaveLoading color="#90be4e" style={{ "marginLeft": "47vw", "marginTop": "5%", "textAlign": "center" }} />;


const {useState} = React;

const col = () =>{
    if (window.innerWidth <= 600){
      return 2;
    }
    else {
      return 4;
    }
  }

const CatImageGridComp = (props) => {

    const [ img, setImg ] = useState(null);
    const [ isOpen, setIsOpen ] = useState(false);

    // const { PhotoDocs } = usePhotoFirestore("photos");
    const { ThumbDocs } = useThumbFirestore("thumbnails");
    const catDocs = ThumbDocs.filter((doc) => doc.genre === props.genre)
    const [ list, setList ] = useState(catDocs.slice(0, 8))
    const [last, setLast] = useState(8);
    const [btnStatus, setStatus] = useState("Load More")
    const [load, setLoad] = useState(null);

    // function findByName(){
    //     let original = PhotoDocs.filter((doc) => doc.name === img.name)[0];
    //     return original;
    // }

    useEffect(()=> {

        setList(catDocs.slice(0, last))

    }, [catDocs, last])


    return (
        <Box padding="8px" border="1px" sx={{ width: '100%',overflowX:'hidden' ,overflowY: 'hidden', margin: 'auto' }}>
            <ImageList variant="masonry" cols={col()} gap={1}>
            {list.map((item, index) => (
                <ImageListItem key={index}>
                <img className="galleryimg contentimg"
                    // onClick={() => this.setState({ img: `${realhost}${item.name}`, isOpen: true})}
                    onClick={() => {
                        setImg(item.imageUrl);
                        setIsOpen(true);
                    }}
                    // src={`${host}${item.name}`}
                    src={`${item.url}`}
                    // srcSet={`${host}${item.name}?w=161&fit=crop&auto=format 1x,
                    // ${host}${item.name}?w=161&fit=crop&auto=format&dpr=2 2x`}
                    srcSet={`${item.url}?w=161&fit=crop&auto=format 1x,
                    ${item.url}?w=161&fit=crop&auto=format&dpr=2 2x`}
                    alt={item.genre}
                    loading="lazy"
                />
                {isOpen && (
                    <Lightbox
                    mainSrc={img}
                    onCloseRequest={() => setIsOpen(false)}
                    imageLoadErrorMessage="Sorry! this image could not be loaded"
                    />
                )}
                </ImageListItem>
            ))}
            </ImageList>
            <button id="loadBtn" onClick={() => {
                if (last >= catDocs.length){
                    setStatus("Its all done!")
                }
                else {
                    setLast(last+8);
                    setStatus("Loading....")        
                    setLoad(WaveAnimation)
                    setTimeout(() => {setStatus("Load More"); setLoad(null)}, 7000);
                }
            }}>{btnStatus}</button>
            {load}
            <br/>
        </Box>
    );
}

export default CatImageGridComp;